// schema
import * as ISchema from "@schema";

export {
  FastCrawlFlowStates,
  FatalFastCrawlFlowStates,
} from "@clockwise/client-commons/src/util/onboarding";

////////////
// COMMON
///////////
import { FLOW_STATE_KEYS } from "./flow-state";

// get the flow state off an org or user
function getGenericFlowState(source: ISchema.IOrg | ISchema.IUser, flowKey: string) {
  if (!source || !source.flowStates || !source.flowStates.edges) {
    return undefined;
  }
  const flowState = source && source.flowStates.edges.filter((fs) => fs.node.flowKey === flowKey);
  return (flowState && flowState.length && flowState[0].node) || undefined;
}

// returns the string value of the current state for a given flow
function getGenericFlowCurrentState(source: ISchema.IOrg | ISchema.IUser, flowKey: string) {
  const flowState = getGenericFlowState(source, flowKey);
  return (flowState && flowState.current && flowState.current.state) || undefined;
}

// checks to see if the current state matches a given value
export function checkState(flowState?: ISchema.IFlowState, step?: string) {
  return !!flowState && !!step && !!flowState.current && flowState.current.state === step;
}

///////////////
// FAST CRAWL
//////////////
export function getFastCrawlFlowState(org: ISchema.IOrg) {
  return getGenericFlowState(org, FLOW_STATE_KEYS.FAST_CRAWL);
}

////////////////
// ONBOARDING
//////////////
// gets the onboarding flow state object off the user
export function getOnboardingFlowState(user: ISchema.IUser) {
  return getGenericFlowState(user, FLOW_STATE_KEYS.INITIAL_ONBOARDING);
}

////////////////
// CHROME FEED
//////////////
export const feedOnboardingKey = FLOW_STATE_KEYS.CHROME_FEED_ONBOARDING;
export enum EFeedOnboardingSteps {
  Welcome = "Unstarted",
  PersonalCalendar = "PersonalCalendar",
  FinishedFirstSet = "CompletedFirstSet", // do not remove for new cards, add below
  CalendarColors = "CalendarColors", // do not remove for new cards, add below
}
// change this when another set is added!
export const FeedOnboardingFinishedStep = EFeedOnboardingSteps.FinishedFirstSet;

export function getFeedOnboardingState(user: ISchema.IUser) {
  return getGenericFlowCurrentState(user, FLOW_STATE_KEYS.CHROME_FEED_ONBOARDING);
}

export function isFeedOnboardingFinished(user: ISchema.IUser) {
  const state = getFeedOnboardingState(user);
  return state === FeedOnboardingFinishedStep;
}

export function getFeedOnboardingSteps() {
  const baseSteps = [EFeedOnboardingSteps.Welcome, EFeedOnboardingSteps.PersonalCalendar];

  return baseSteps;
}
